export default "__VITE_ASSET__BlZGasap__"